import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeletePartner($id: Int!) {
    deletePartner(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deletePartner: {
    id?: number;
  };
}
